import { ProcedureStepFieldsService as OvermapProcedureStepFieldsService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class ProcedureStepFieldsService extends OvermapProcedureStepFieldsService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
